import Text from "antd/lib/typography/Text";
import { theme } from "antd";

interface Props {
  title: string;
}

const GroupTitleMenu = ({ title }: Props) => {
  const {
    token: { colorText },
  } = theme.useToken();
  return (
    <Text className="group-title-menu" style={{ color: colorText }}>
      {title}
    </Text>
  );
};

export default GroupTitleMenu;
